<template>
  <div class="is-flex">
    <up-label class="py-2" :label="label" :labelIcon="labelIcon"></up-label>
    <label class="switch my-2">
      <input @change="randomColor()" v-model="up_switch" type="checkbox" />
      <span ref="colorinput" class="slider round"></span>
      
    </label>
  </div>
</template>

<script>
import UpLabel from "../Label";
import { addRandomBorderColor } from "./RandomColor.js";
export default {
  name: "up-switch",
  props: {
    label: {
      type: String,
    },
    labelIcon: {
      type: String,
      default: "",
    },
    value : {
      type : Boolean
    }
  },
  components: {
    UpLabel,
  },
  data() {
    return {
      up_switch: false,
      randColor: addRandomBorderColor,
    };
  },
  methods: {
    randomColor() {
      let color = this.randColor();

      let input_element = this.$refs.colorinput;
      if (input_element.style.background == "") {
        input_element.style.background = color;
      } else {
        input_element.style.background = "";
      }
    },
    defaultColor() {
      let input_element = this.$refs.colorinput;
      input_element.style.border = "2px solid black";
    },
  },
  watch: {
    up_switch: {
      handler: function(new_val) {
        this.$emit("input", new_val);
      },
    },
    value: function(new_val) {
      this.up_switch = new_val;
      if(new_val){
        this.randomColor()
      }
      
    },
  },
};
</script>

<style scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 55px;
  height: 27px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider:before {
  -webkit-transform: translateX(24px);
  -ms-transform: translateX(24px);
  transform: translateX(24px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 0px;
}

.slider.round:before {
  border-radius: 0%;
}
</style>
